import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import '../src/styles/globals.css'
import LandingPage from "./component/common/LandingPage/LandingPage";
import PortalPage from "./pages/portal";
import NoMatch from "./component/common/404/404";
import Forbidden from "./component/common/forbidden/forbidden";


const App: React.FC = () => {

    return (
        <Router>
            <main className="main-content">
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/ecomp/:encryfileid" element={<PortalPage />} />
                    <Route path="/sessionexpired" element={<Forbidden />} />
                    <Route path="*" element={<NoMatch />} />
                </Routes>
            </main>
        </Router>
    );
};

export default App;
